import { useSnapshot } from 'valtio'
import uiState from '../data'
import { motion, AnimatePresence } from 'framer-motion'
import { windowSizeState } from '../utils/windowSize'
import { useEffect, useState } from 'react'
import { googleSheet } from '../utils/getSheet'

const imagePaths = [
  '../startImages/pic/Main_VE_Bg01_PC.png',
  '../startImages/pic/Main_VE_Bg02_PC.png',
  '../startImages/pic/Main_VE_Bg03_PC.png',
  '../startImages/pic/Main_VE_Bg04_PC.png',
  '../startImages/pic/Main_VE_Bg05_PC.png',
  '../startImages/pic/Main_VE_Bg06_PC.png',
  '../startImages/pic/Main_VE_Bg07_PC.png',
  '../startImages/pic/Main_VE_Bg08_PC.png'
]

const imagePathsPh = [
  '../startImages/pic/Main_VE_Bg01_MB.png',
  '../startImages/pic/Main_VE_Bg02_MB.png'
]

const ImageSlider = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0)
  const [bgImageIndex, setBgImageIndex] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [isBgLoading, setIsBgLoading] = useState(false)

  const loadImage = (index) => {
    const img = new Image()
    img.src = imagePaths[index]
    return new Promise((resolve) => {
      img.onload = () => {
        resolve()
      }
    })
  }

  useEffect(() => {
    ;(async () => {
      await loadImage(bgImageIndex)
      setIsBgLoading(true)
    })()
  }, [bgImageIndex])

  useEffect(() => {
    if (isBgLoading) {
      const interval = setInterval(async () => {
        setIsLoading(false)

        await Promise.all([
          loadImage(currentImageIndex),
          loadImage((bgImageIndex + 1) % imagePaths.length)
        ])

        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % imagePaths.length)
        setIsLoading(true)
        setBgImageIndex((prevIndex) => (prevIndex + 1) % imagePaths.length)
        setIsLoading(false)
      }, 5000)

      return () => clearInterval(interval)
    }
  }, [currentImageIndex, bgImageIndex, isBgLoading])

  return (
    <div className='absolute top-1/2 w-[90%] -translate-y-[40%] right-0 translate-x-[40%] h-[180%] z-20'>
      <AnimatePresence>
        {isBgLoading && (
          <motion.img
            key={currentImageIndex}
            src={imagePaths[currentImageIndex]}
            alt='上層圖片'
            className='h-full absolute top-0 left-0'
            initial={{ opacity: 0 }}
            animate={{ opacity: isLoading ? 1 : 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.4 }}
            onLoad={() => {
              setIsLoading(true)
            }}
          />
        )}
      </AnimatePresence>
      {isBgLoading && (
        <AnimatePresence>
          <motion.img
            key={bgImageIndex}
            src={imagePaths[bgImageIndex]}
            alt='下層圖片'
            className='h-full z-20'
            transition={{ duration: 1.4 }}
            onLoad={() => {
              setIsBgLoading(true)
            }}
          />
        </AnimatePresence>
      )}
    </div>
  )
}

const ImageSliderPh = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0)
  const [bgImageIndex, setBgImageIndex] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [isBgLoading, setIsBgLoading] = useState(false)

  const loadImage = (index) => {
    const img = new Image()
    img.src = imagePathsPh[index]
    return new Promise((resolve) => {
      img.onload = () => {
        resolve()
      }
    })
  }

  useEffect(() => {
    ;(async () => {
      await loadImage(bgImageIndex)
      setIsBgLoading(true)
    })()
  }, [bgImageIndex])

  useEffect(() => {
    if (isBgLoading) {
      const interval = setInterval(async () => {
        setIsLoading(false)

        await Promise.all([
          loadImage(currentImageIndex),
          loadImage((bgImageIndex + 1) % imagePathsPh.length)
        ])
        setBgImageIndex((prevIndex) => (prevIndex + 1) % imagePathsPh.length)
        setTimeout(() => {
          setCurrentImageIndex(
            (prevIndex) => (prevIndex + 1) % imagePathsPh.length
          )
          setIsLoading(true)
        }, 200)

        setIsLoading(false)
      }, 5000)

      return () => clearInterval(interval)
    }
  }, [currentImageIndex, bgImageIndex, isBgLoading])

  return (
    <div className='absolute bottom-0 left-0 w-full aspect-[1/0.6]  z-20 '>
      <AnimatePresence>
        {isBgLoading && (
          <motion.img
            key={currentImageIndex}
            src={imagePathsPh[currentImageIndex]}
            alt='上層圖片'
            className='w-full h-full absolute bottom-0 left-0 z-10 object-cover'
            initial={{ opacity: 0 }}
            animate={{ opacity: isLoading ? 1 : 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.4 }}
            onLoad={() => {
              setIsLoading(true)
            }}
          />
        )}
      </AnimatePresence>

      <AnimatePresence>
        <motion.img
          key={bgImageIndex}
          src={imagePathsPh[bgImageIndex]}
          alt='下層圖片'
          className=' absolute bottom-0 left-0 w-full h-full object-cover  '
          transition={{ duration: 1.4 }}
          onLoad={() => {
            setIsBgLoading(true)
          }}
        />
      </AnimatePresence>
    </div>
  )
}

const CommunityPage = ({ event }) => {
  const { visible } = useSnapshot(uiState[event])
  const { mobileMode } = useSnapshot(windowSizeState)

  const data = googleSheet['homepage'].filter((el) => {
    return el.part === `jupiter's_community`
  })[0]

  const goEnterPage = () => {
    uiState.enterPage.visible = true
    uiState[event].visible = false
  }
  const goVE = () => {
    let currentUrl = window.location.href
    let newUrl = currentUrl.replace('/start/start.html', '/ve/khs_ve.html')
    window.location.href = newUrl
    uiState[event].visible = false
  }

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className='screen-setting overflow-hidden fixed top-0 '
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
        >
          <img
            src='../startImages/bg/bg.jpg'
            alt='背景圖片'
            className='w-full h-full'
          />
          <img
            src='../startImages/line/line2.png'
            alt='背景線'
            className='absolute top-0 left-[50px] h-full '
          />
          <img
            src='../startImages/icon/back.png'
            alt='返回鍵'
            className={`absolute top-[80px] portraitPad:top-[70px]  left-[180px] portraitPad:left-[10%] smallLaptop:left-[10%] landscapePad:left-[10%] landscapePad:top-[70px] authPCHeight:left-[10%]  w-[110px] portraitBigPh:w-[70px] portraitBigPh:top-[50px] landscapePhone:w-[70px] landscapePhone:top-[50px] landscapePhone:left-[10%] cursor-pointer ${
              !mobileMode && 'opacity-70'
            } hover:opacity-100 `}
            onClick={goEnterPage}
          />
          {mobileMode ? <ImageSliderPh /> : <ImageSlider />}

          <div className=' absolute top-0 left-1/2 -translate-x-1/2 flex flex-col items-center'>
            <div>
              <img
                src='../startImages/logo/color.png'
                alt='logo 彩色部分'
                className='w-[50px]  portraitBigPh:w-[30px] landscapePhone:w-[30px]'
              />
            </div>
            <div>
              <img
                src='../startImages/logo/big_logo.png'
                alt='黑色 logo'
                className='w-[100px] portraitBigPh:w-[75px] landscapePhone:w-[75px]'
              />
            </div>
          </div>
          <div className='h-[45%] w-[35%] absolute top-[55%] z-20 -translate-y-1/2 left-[180px] flex flex-col smallLaptop:h-[55%] justify-between items-start smallLaptop:left-[10%] portraitPad:w-[80%]  portraitPad:left-1/2 portraitPad:-translate-x-1/2 portraitPad:-translate-y-0 portraitPad:top-[20%] portraitPad:h-[35%] landscapePad:left-[10%] landscapePad:h-[63%] portraitBigPh:top-[calc(40%+20px)] portraitBigPh:h-[50%] portraitBigPh:-translate-y-1/2 landscapePhone:top-[60%] landscapePhone:-translate-y-1/2 landscapePhone:w-[80%] landscapePhone:left-1/2 landscapePhone:-translate-x-1/2 landscapePhone:h-[55%] authPCHeight:w-[80%] authPCHeight:left-1/2 authPCHeight:-translate-x-1/2 authPCHeight:top-[40%] authPCHeight:h-[35%]  '>
            <div className='Trajan text-[40px] smallLaptop:text-[30px] landscapePad:text-[30px] portraitPh:text-[20px] portraitPh:mb-4 landscapePhone:text-[20px] landscapePhone:mb-3 '>
              <p>{data.en_title1}</p>
            </div>
            <div className='portraitPh:mb-4 landscapePhone:overflow-y-auto landscapePhone:mb-4 landscapePhone:pr-3  mb-2 shortPhone2:overflow-y-scroll'>
              <i className='text-[17px] smallLaptop:text-[15px]  portraitPh:text-[15px] landscapePhone:text-[15px]  '>
                {data.en_content1}
              </i>
            </div>
            <div className='box-border  h-[50px] flex justify-center portraitPh:h-[40px] landscapePhone:h-[40px]'>
              <button
                className='Trajan  border-mainOrange-100 px-7 portraitPh:px-5 landscapePhone:px-5 h-full py-[10px] portraitPh:py-[5px] landscapePhone:py-[5px] text-[16px] portraitPh:text-[14px] rounded-full shadow-lg  border-2 hover:border-4 bg-white '
                onClick={goVE}
              >
                {data.en_btn1}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default CommunityPage
